/* HEADER SLIDERS START */

const slides = document.querySelectorAll(".header-slide");
const next = document.querySelector("#slideNext");
const prev = document.querySelector("#slidePrev");
const sliderSettings = document.getElementById('header-slider-settings');

// global variables scrolling
const auto = sliderSettings.dataset.rotate === 'true' ? true : false;
const hasBtns = prev != null && next != null;
const intervalTime = sliderSettings.dataset.speed * 1000; //ms
let autoScrollBack = false;
let slideInterval;

// set initial slide to 0
slides[0].classList.add("current");
if(hasBtns) {
  prev.style.opacity = "0.5";
  prev.setAttribute('disabled', '')
}

// Indicator func
function indicatorSlide() {
  const indicator = document.querySelector(".header-buttons-indicator");
  // slides[0].classList.add('current')

  for (let i = 0; i < slides.length; i++) {
    const element = slides[i];

    // creates a dot for each slide
    const dot = document.createElement("span");
    dot.classList.add("indicator-dot");
    indicator.appendChild(dot);

    // when dot is clicked move to slide
    dot.addEventListener("click", () => {
      const current = document.querySelector(".current");
      current.classList.remove("current");
      element.classList.add("current");
      
    });
  }

  // adding functionality for dot styling
  const dots = document.querySelectorAll(".indicator-dot");
  dots[0].classList.add("indicator-dot-active");

  for (let i = 0; i < dots.length; i++) {
    const element = dots[i];

    // when dot element is click remove previous dot class and add new
    element.addEventListener("click", () => {
      const current = document.querySelector(".indicator-dot-active");
      current.classList.remove("indicator-dot-active");
      element.classList.add("indicator-dot-active");
    });
  }
}

// active indicator
function activeIndicator(x) {
  const dots = document.querySelectorAll(".indicator-dot");

  for (let i = 0; i < dots.length; i++) {
    const element = dots[i];
    element.classList.remove("indicator-dot-active");
    dots[x.id].classList.add("indicator-dot-active");
  }
}

// next slider btn
function nextSlide() {
  const current = document.querySelector(".current");
  const dots = document.querySelectorAll(".indicator-dot");

  if(autoScrollBack) {
    slides[slides.length -1].classList.remove("current");
    slides[0].classList.add("current");
    activeIndicator(document.querySelector(".current"));
    next.style.opacity = "1"
    next.removeAttribute('disabled')
    prev.style.opacity = "0.5"
    prev.setAttribute('disabled', '')
    autoScrollBack = false;
    return;
  }

  if (!current.nextElementSibling.nextElementSibling){
      next.style.opacity = "0.5"
      next.setAttribute('disabled', '')
      autoScrollBack = true;
  } else {
      next.style.opacity = "1"
      next.removeAttribute('disabled')
  } 

  if (!current.previousElementSibling){
      prev.style.opacity = "1"
      prev.removeAttribute('disabled')
  }

  if (current.nextElementSibling) {
    current.nextElementSibling.classList.add("current");
    activeIndicator(current.nextElementSibling);
    setTimeout(() => current.classList.remove("current"));
  }
//   setTimeout(() => current.classList.remove("current"));
}

// prev slider btn
function prevSlide() {
  const current = document.querySelector(".current");
  const dots = document.querySelectorAll(".indicator-dot");

  if(!current.previousElementSibling.previousElementSibling){
    prev.style.opacity = "0.5"
    prev.setAttribute('disabled', '')
  } else{
    prev.style.opacity = "1"
    prev.removeAttribute('disabled')
  }

  if(!current.nextElementSibling){
      next.style.opacity= "1"
      next.removeAttribute('disabled')
  }


  if (current.previousElementSibling) {
    current.previousElementSibling.classList.add("current");
    activeIndicator(current.previousElementSibling);
    setTimeout(() => current.classList.remove("current"));
    
  } else {
    // slides[slides.length - 1].classList.add("current");
    // dots[slides.length - 1].classList.add("indicator-dot-active");
    // dots[0].classList.remove("indicator-dot-active");
  }
//   setTimeout(() => current.classList.remove("current"));
}

// auto slider
if (auto && hasBtns) {
  // document.querySelector('.header-buttons').style.display = "none"
  slideInterval = setInterval(nextSlide, intervalTime);
}

// if the slider has buttons
if (hasBtns) {
  next.addEventListener("click", (e) => {
    nextSlide();

    if (auto) {
      clearInterval(slideInterval);
      slideInterval = setInterval(nextSlide, intervalTime);
    }
  });
  prev.addEventListener("click", (e) => {
    prevSlide();
    clearInterval(slideInterval);
    slideInterval = setInterval(nextSlide, intervalTime);
  });
}

if (slides.length > 1) {
  indicatorSlide();
}

/* HEADER SLIDER END */